export class PushNotificationsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRecipientsPreview({ companyId } = {}) {
    return this.#http.get('api/push-notifications/dispatch/recipients/preview', {
      params: { companyId },
    });
  }

  async dispatchNotification(payload) {
    return this.#http.post('api/push-notifications/dispatch', payload);
  }

  async dispatchCrossCompanyNotification(payload) {
    return this.#http.post('api/push-notifications/dispatch/cross-company', payload);
  }

  async getNotifications(userId, params) {
    return this.#http.get(`api/users/${userId}/push-notifications`, { params });
  }

  async getStatistics(userId) {
    return this.#http.get(`api/users/${userId}/push-notifications/statistics`);
  }

  async updateNotification(userId, notificationId, body) {
    return this.#http.put(`api/users/${userId}/push-notifications/${notificationId}`, body);
  }

  async markAllAsRead(userId) {
    return this.#http.put(`api/users/${userId}/push-notifications`, { isRead: true });
  }

  async registerDevice(payload) {
    return this.#http.post('api/devices/register', payload);
  }

  async unregisterDevice(deviceUuid) {
    return this.#http.post('api/devices/unregister', { deviceUuid });
  }

  async sendDeviceHeartbeat(payload) {
    return this.#http.post('api/devices/heartbeat', payload);
  }
}
